import HttpWrapper from '@/utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'

const MEMBERSHIP_API = ShipbobAppSettings.membershipApi
export const merchantOrganizationTypeId = '4fd26cc1-36ee-42ea-ba05-d38a369e35f6'

export default class MembershipService {
  static async getOrganization (orgId) {
    const request = {
      Url: `${MEMBERSHIP_API}/API/V1/Organization/${orgId}`
    }
    return await HttpWrapper.Get(request)
      .then(response => ({ data: response, success: true }))
      .catch(error => {
        console.log(`Failed to fetch organization:  ${error.response?.data?.errors.join(',')}`)
        return { error, success: false }
      })
  }

  static async getSubaccountInvite (orgId) {
    const request = {
      Url: `${MEMBERSHIP_API}/API/V1/Subaccount/invite?organizationId=${orgId}`
    }
    return await HttpWrapper.Get(request, null, null, true)
      .then(response => ({ data: response, success: true }))
      .catch(error => {
        console.log(`Failed to fetch invites:  ${error.response?.data?.errors.join(',')}`)
        return { error, success: false }
      })
  }

  static async getMerchantOrganizations (identityId) {
    const request = {
      Url: `${MEMBERSHIP_API}/API/V1/UserIdentity/${identityId}/Organizations?OrganizationTypeIds=${merchantOrganizationTypeId}`
    }

    try {
      const response = await HttpWrapper.Get(request)
      return { data: response, success: true }
    } catch (error) {
      const errorMessages = error?.response?.data?.errors
      const joinedErrors = Array.isArray(errorMessages) ? errorMessages.join(',') : errorMessages || 'Unknown error'
      console.log(`Failed to fetch merchant organizations: ${joinedErrors}`)
      return { error, success: false }
    }
  }
}

